import axios from 'axios'
import { CADASTRAR_CONTROLE_EMISSAO_BPE } from '../types'
import { URL } from '../../util/ambienteActions';
import {SLOW_REQUEST_HEADER} from '../../util/loadingUtil';

export default function cadastrarControleEmissaoBpeEmLote (config) {
  const url = `${URL}/controle-emissao-bpe/cadastrar-em-lote`;

  return dispatch => axios.post(url, config, SLOW_REQUEST_HEADER).then(
      response => dispatch({
        type: CADASTRAR_CONTROLE_EMISSAO_BPE,
        payload: response
      })
  );
}
